import * as types from '../actions/action-types';

const initialState = {
  firstName: '',
  lastName: '',
};

export default function spotiiReducer(state = initialState, action) {
  if (action.type === types.UPDATE_SPOTII_FORM) {
    return {
      ...state,
      [action.fieldName]: action.value,
    };
  }
  return state;
}
